/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinginstagramtitle2Inputs */

const en_crosspostinginstagramtitle2 = /** @type {(inputs: Crosspostinginstagramtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post to Instagram`)
};

const de_crosspostinginstagramtitle2 = /** @type {(inputs: Crosspostinginstagramtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Instagram posten`)
};

/**
* | output |
* | --- |
* | "Post to Instagram" |
*
* @param {Crosspostinginstagramtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinginstagramtitle2 = /** @type {((inputs?: Crosspostinginstagramtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinginstagramtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinginstagramtitle2(inputs)
	return de_crosspostinginstagramtitle2(inputs)
});
export { crosspostinginstagramtitle2 as "crosspostingInstagramTitle" }